import React, { FC, memo } from "react";
import ContactExpert from "@modules/Layout/components/ContactExpert";
import GetInTouch from "@modules/Layout/components/GetInTouch";
import BuildFlag from "@modules/Layout/components/BuildFlag";
import LoadingScreen from "@modules/Layout/components/LoadingScreen";
import ErrorScreen from "@modules/Layout/components/ErrorScreen";
import { navigate } from "gatsby";
import Cover from "./Cover";
import ProductCards from "./ProductCards";
import useProductCategoryPageAttr from "../hooks/useProductCategoryPageAttr";

interface IProps {}

const ProductCategory: FC<IProps> = () => {
  const { isLoading, isError, data: pageData } = useProductCategoryPageAttr();

  if (!isLoading && pageData?.error?.status === 404) {
    navigate("/contact-us/");
    return null;
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isError) {
    return <ErrorScreen />;
  }

  return (
    <>
      <Cover />
      <GetInTouch />
      <ProductCards />
      <BuildFlag />
      <ContactExpert />
    </>
  );
};

export default memo(ProductCategory);
